module.exports = __webpack_public_path__ + "img/P150T_weapon_1.486c2408.png";